// extracted by mini-css-extract-plugin
module.exports = {"MenuActions__menu__27ETX":"MenuActions__menu__27ETX","js-focus-visible":"js-focus-visible","focus-visible":"focus-visible"};